const formatPhone = (telephone) => {
    if (!telephone) return telephone;

    const raw = String(telephone).trim();
    const hasPlus = raw.startsWith("+");

    let digits = raw.replace(/\D/g, "");
    if (!digits || !isNumber(digits)) {
        return telephone;
    }

    if (
        hasPlus &&
        digits.startsWith("55") &&
        (digits.length === 12 || digits.length === 13)
    ) {
        return `+${digits}`;
    }

    if (
        !hasPlus &&
        digits.startsWith("55") &&
        (digits.length === 12 || digits.length === 13)
    ) {
        return `+${digits}`;
    }

    digits = digits.replace(/^0+/, "");

    // 10–11 dígitos: assume DDD + número BR → prefixa +55
    if (digits.length === 10 || digits.length === 11) {
        return `+55${digits}`;
    }

    // 7–9 dígitos: trata como número local (sem DDD / sem DDI)
    if (digits.length >= 7 && digits.length <= 9) {
        return digits;
    }

    // >13 dígitos ou formatos estranhos: devolve com + só pra não perder
    if (digits.length > 13) {
        return `+${digits}`;
    }

    // Qualquer outro caso (muito curto etc.): devolve os dígitos crus
    return digits;
}

const isNumber = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export default formatPhone